<script lang="ts" setup>
import { InputState, InputSize } from "@/components/Form/Input/InputEnums"
import { computed } from "vue"

const props = defineProps<{
   forId?: string
   state?: InputState
   size?: InputSize
   disabled?: boolean
}>()

const stateClass = computed(() => ({
   "labeled-control--error": props.state === InputState.Error
}))

const sizeClass = computed(() => ({
   "labeled-control--large": props.size === InputSize.Large
}))

const disabledClass = computed(() => ({
   "labeled-control--disabled": props.disabled === true
}))
</script>

<template>
   <div :class="['labeled-control', stateClass, sizeClass, disabledClass]">
      <label class="labeled-control__label" :for="forId">
         <slot name="label" />
      </label>
      <slot name="form-control" />
      <div class="labeled-control__additional-text" :for="forId">
         <slot name="additional-text" />
      </div>
   </div>
</template>
